import React from 'react';

import { st, classes } from './Loader.st.css';

export const Loader: React.FC<{ className?: string }> = (props) => (
  <div className={st(classes.root, {}, props.className)} />
);
